<div class="container">
    <h1 class="title" *ngIf="title">{{title}}</h1>
    <div class="caption" *ngIf="caption">{{caption}}</div>
    <div class="see-more" *ngIf="isSeeMoreAvailable()"><span (click)="seeMoreClickFn()">See More</span></div>

    <ng-container *ngIf="isSmScreen"><ng-container *ngTemplateOutlet="carouselTemplate; context: { list: patchCarouselPages(smItems), items: smItems}"></ng-container></ng-container>
    <ng-container *ngIf="isMdScreen"><ng-container *ngTemplateOutlet="carouselTemplate; context: { list: patchCarouselPages(mdItems), items: mdItems}"></ng-container></ng-container>
    <ng-container *ngIf="isLgScreen"><ng-container *ngTemplateOutlet="carouselTemplate; context: { list: patchCarouselPages(lgItems), items: lgItems}"></ng-container></ng-container>
    <ng-container *ngIf="isXlScreen"><ng-container *ngTemplateOutlet="carouselTemplate; context: { list: patchCarouselPages(xlItems), items: xlItems}"></ng-container></ng-container>
</div>

<ng-template #carouselTemplate let-list="list" let-items="items">
    <nz-carousel [nzDots]="patchCarouselPages(list)?.length > 1" [nzEffect]="'scrollx'" [nzDotRender]="dotTemplate" #carouselComponent>
        <div nz-carousel-content *ngFor="let page of list;let pageIndex = index;">
            <div class="carousel-content">
                <div *ngFor="let item of items; let i = index" class="carousel-item">
                    <leap-product-card *ngIf="products[i + pageIndex * items.length] as product"
                       [id]="product.id"
                       [sku]="product.sku"
                       [name]="product.name"
                       [type]="product?.typeConfig?.configValue"
                       [price]="product.pricing?.amount"
                       [currency]="product.pricing?.currency"
                       [shortDescription]="product.shortDescription"
                       [variants]="product.productVariants"
                       [isBundleType]="product?.typeConfig?.configKey === 'bundle-product'"
                       [bundle]="product?.bundle"

                       [addLineItemSku]="addLineItemSku"
                       [addLineItemPending]="addLineItemPending"

                       [currencySignsMap]="currencySignsMap"

                       [sellerImageUrl]="product.seller.logo"
                       [sellerName]="product.seller.displayName"
                       [hasAccess]="product.restriction?.hasAccess"
                       [restricted]="product.restriction?.restricted"
                       [isNotContractedSupplier]="product.restriction?.isNotContractedSupplier"

                       [isLogged]="isLogged"

                       (goToDetails)="goToRelatedProductDetails($event)"
                       (addToCart)="addRelatedProductToCart($event)">
                    </leap-product-card>
                </div>
            </div>
        </div>
    </nz-carousel>
</ng-template>

<ng-template #dotTemplate>
    <div class="dot"></div>
</ng-template>
